import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CheckCircle } from 'lucide-react';
import logo from '../Fxer.AI (7).png';

const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        audience: "https://fxer.ai/api",
        scope: "read:all",
        redirect_uri: window.location.origin,
      },
    });
  };

  const handleSignUp = () => {
    loginWithRedirect({
      authorizationParams: {
        audience: "https://fxer.ai/api",
        scope: "read:all",
        redirect_uri: window.location.origin,
      },
    });
  };

  return (
    <div className="flex justify-center px-4 pt-16 md:pt-24">
      <div className="max-w-4xl w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left — Value prop */}
        <div>
          <img src={logo} alt="Fxer" className="h-20 mb-6" />
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Unlock your property's potential
          </h1>
          <p className="text-gray-600 mb-6">
            Fxer provides in-depth insights into your property — whether you're buying, selling, or investing.
          </p>
          <div className="space-y-3">
            {[
              'Generate renovation estimates from photos',
              'Analyze contractor bids for accuracy',
              'Review inspection reports instantly',
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2.5">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span className="text-sm text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right — Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleLogin}
            className="w-full py-3 px-4 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
          >
            Log In
          </button>
          <button
            onClick={handleSignUp}
            className="w-full py-3 px-4 bg-white text-gray-900 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
